import {
  BarChartOutlined,
  BlockOutlined,
  BookOutlined,
  BoxPlotOutlined,
  BranchesOutlined,
  ClusterOutlined,
  FolderViewOutlined,
  LaptopOutlined,
  SubnodeOutlined,
} from '@ant-design/icons';
import { DimaContext } from '../../DimaContext';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import React, { useContext } from 'react';

const SiderMenu = () => {
  const context = useContext(DimaContext);
  // TODO: NAVIGATING VIA URL SETS THE SELECTEDKEY TO DEFAULT. SELECTION SHOULD REFLECT URL
  return (
    <Menu
      mode="inline"
      theme="dark"
      defaultSelectedKeys={['nav-fhir-mapping']}
      style={{
        height: '100%',
        borderRight: 0,
      }}
    >
      <Menu.Item key="nav-fhir-mapping" icon={<BranchesOutlined />} data-cy="nav-fhir-mapping">
        <Link to={`/map/${context.client.id}/mappings`} onClick={context.handleClick}>
          FHIR Mappings
        </Link>
      </Menu.Item>
      <Menu.Item icon={<BookOutlined />} data-cy="nav-summary">
        <Link to={`/map/${context.client.id}/summary`} onClick={context.handleClick}>
          Review Summary
        </Link>
      </Menu.Item>
      <Menu.Item icon={<FolderViewOutlined />} data-cy="nav-groovy-lib">
        <Link to={`/map/${context.client.id}/groovy_library`} onClick={context.handleClick}>
          Groovy Library
        </Link>
      </Menu.Item>
      <Menu.Item icon={<LaptopOutlined />} data-cy="nav-data-sources">
        <Link to={`/map/${context.client.id}/data_sources`} onClick={context.handleClick}>
          Data Sources
        </Link>
      </Menu.Item>
      <Menu.Item icon={<BoxPlotOutlined />} data-cy="nav-fhir-server-viewer">
        <Link to={`/map/${context.client.id}/fhir_server_viewer`} onClick={context.handleClick}>
          FHIR Server Viewer
        </Link>
      </Menu.Item>
      <Menu.Item icon={<BarChartOutlined />} data-cy="nav-patient-viewer">
        <Link to={`/map/${context.client.id}/patient_viewer`} onClick={context.handleClick}>
          Patient Viewer
        </Link>
      </Menu.Item>
      <Menu.Item icon={<SubnodeOutlined />} data-cy="nav-reference-viewer">
        <Link to={`/map/${context.client.id}/reference_viewer`} onClick={context.handleClick}>
          Reference Viewer
        </Link>
      </Menu.Item>
      <Menu.Item icon={<ClusterOutlined />} data-cy="nav-dis-viewer">
        <Link to={`/map/${context.client.id}/ingestion`} onClick={context.handleClick}>
          Data Ingestion Dashboard
        </Link>
      </Menu.Item>
      <Menu.Item icon={<BlockOutlined />} data-cy="nav-data-contracts">
        <Link to={`/map/${context.client.id}/data_contracts`} onClick={context.handleClick}>
          Data Contracts
        </Link>
      </Menu.Item>
    </Menu>
  );
};

export default SiderMenu;
